<template lang="pug">
div#site
    navbar(:color="navbarColor")
    router-view.wrap(@init="changePage" @end-loading="endLoading" v-slot="{ Component }")
        transition(
            name="fade-page" mode="out-in"
            @before-leave="colorize(true, 'begin')" @before-enter="colorize(true, 'middle')" @after-enter="colorize(false, 'end')"
        )
            component(:is="Component")
    footerbar(v-show="!!footerColor" :color="footerColor")
    loader(v-show="showLoader" :color="navbarColor")
    cookie-consent
</template>

<script>
import { useHead } from "@vueuse/head";
import Navbar from "./components/layouts/Navbar.vue";
import Footer from "./components/layouts/Footer.vue";
import Loader from "./components/layouts/Loader.vue";
import CookieConsent from "./components/layouts/CookieConsent.vue";

export default {
  name: "App",
  components: {
    navbar: Navbar,
    footerbar: Footer,
    loader: Loader,
    "cookie-consent": CookieConsent,
  },
  setup() {
    useHead({
      title: "Page title",
      titleTemplate: "%s",
      meta: [
        { vmid: "ogimage", property: "og:image", content: "" },
        { property: "og:locale", content: "ru-RU" },
        { property: "og:locale:alternate", content: "en-US" },
        { property: "og:site_name", content: "Sota." },
        { property: "og:see_also", content: "http://sota.media" },
        { name: "twitter:site", content: "Sota." },
        { name: "twitter:domain", content: "http://sota.media" },
        { vmid: "twitterimage", name: "twitter:image:src", content: "" },
      ],
    });
  },
  data() {
    return {
      transition: {
        mode: "out-in",
        colorize: false,
      },
      navbarColor: "white",
      footerColor: null,
      showLoader: false,
    };
  },
  created() {
    this.$http.get("pages/contacts").then((response) => {
      const excludeLinks = ["Youtube", "Instagram"];
      const newData = response.data;
      newData.social = newData.social.filter(
        (link) => !excludeLinks.includes(link.name),
      );
      this.$store.commit("setContacts", newData);
    });
    this.$http.get("pages/main").then((response) => {
      this.$store.commit("setSocialImage", response.data.socialImage);
    });
  },
  methods: {
    changePage(navbarColor, footerColor) {
      console.log("changePage called with:", { navbarColor, footerColor });
      this.navbarColor = navbarColor;
      this.footerColor = footerColor;
      this.showLoader = true;
    },
    setup() {
        useHead({
            title: 'Sota — Видеопродакшн',
            titleTemplate: (title) => {
                // Если title пустой или это дефолтный "Sota.", возвращаем просто "Sota."
                if (!title || title === 'Sota — Видеопродакшн') return 'Sota — Видеопродакшн'
                // Иначе применяем шаблон
                return `${title}`
            },
            meta: [
                { vmid: 'ogimage', property: "og:image", content: '' },
                { property: "og:locale", content: 'ru-RU' },
                { property: "og:locale:alternate", content: 'en-US' },
                { property: "og:site_name", content: "Sota — Видеопродакшн" },
                { property: "og:see_also", content: "http://sota.media" },
                { name: "twitter:site", content: "Sota — Видеопродакшн" },
                { name: "twitter:domain", content: "http://sota.media" },
                { vmid: 'twitterimage', name: "twitter:image:src", content: '' }
            ]
        })
    },
    colorize(colorize, step) {
      document.body.style.background =
        this.transition.colorize && colorize ? "black" : "white";
      if (step == "end") {
        var routesName = ["Main", "Projects", "Project"];
        document.body.style.background = routesName.includes(this.$route.name)
          ? "black"
          : "white";
      }
    },
  },
  watch: {
    $route(to, from) {
      var routesName = ["Main", "Projects", "Project"];
      this.transition.colorize =
        routesName.includes(to.name) && routesName.includes(from.name);
    },
  },
};
</script>

<style lang="scss">
@import "@styles/base.scss";
.wrap {
  position: relative;
  margin-top: -70px;
  padding-top: 70px;
}
</style>
